export default __webpack_public_path__ + "static/media/InvoiceFrenchCDLogo.2fb02425.png";